export default "__VITE_ASSET__koPY6In___"